import Checkbox from "expo-checkbox";
import { StyleSheet, View } from "react-native";
import CustomText from "./CustomText";
import { TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

const CustomCheckBoxSelection = ({
  isMultiple = false,
  options = [],
  value = 0, // bitwise value
  onChange = () => {},
  size = 23,
  labelStyle = {},
  color = "#508BC9",
  defaultValue = 0,
}) => {
  const handleOnValueChange = ({ iValue, isChecked }) => {
    const bitValue = parseInt(iValue, 10);
    let nValue;

    if (isMultiple) {
      nValue = isChecked ? value & ~bitValue : value | bitValue;
    } else {
      nValue = isChecked ? 0 : bitValue;
    }
    onChange(nValue || defaultValue);
  };

  return (
    <View style={styles.container}>
      {options.map(({ value: iValue, label }) => {
        const bitValue = parseInt(iValue, 10);
        const isChecked = (value & bitValue) !== 0;
        return (
          <View key={label} style={styles.section}>
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => handleOnValueChange({ iValue, isChecked })}
            >
              <Icon
                name={isChecked ? "checkbox-outline" : "checkbox-blank-outline"}
                size={size}
                color={color}
              />
            </TouchableOpacity>
            <CustomText
              style={[styles.text, labelStyle]}
              onPress={() => handleOnValueChange({ iValue, isChecked })}
            >
              {label}
            </CustomText>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    marginBottom: 5,
  },
  section: { flexDirection: "row", marginVertical: 3, alignItems: "flex-end" },
  text: { fontSize: 10, marginLeft: 3, marginRight: 3 },
});
export default CustomCheckBoxSelection;
